import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import './header.css';

import Navbar from '../Navbar/navbar';

class Header extends React.Component {


  static propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string
  }

  static defaultProps = {
    image: undefined,
    title: "Hello World",
    subtitle: ""
  }

  render() {
    return (
      <div className={"header"}>
        <img src={this.props.image}/>
        <div className={"container"}>
          <Navbar/>
          <div className={"row"}>
            <h1 className={"col-xs-12 col-sm-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 col-xl-10"}>{this.props.title}</h1>
          </div>
          <div className={"row"}>
            <p className={"col-xs-12 col-sm-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 col-xl-10 subtitle"}>{this.props.subtitle}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/header.js